
import AutocompleteDropdownWithChip from './AutocompleteDropdownWithChip';
import {
    useSearchUserIds,
  } from '../unify-admin/apps/useAppQueries';
import {useEffect, useState} from 'react';
import { useAppAdminStore } from '../unify-admin/apps/useAppAdminStore';
import { useTranslation } from 'react-i18next';

export type DropdownValue = {
    label: string;
    value: string;
  };

export const createUserIdDropdownOptions = (
    data: any
  ): DropdownValue[] => {
    const options: any = [];
    data?.forEach((element : any) =>{
        options.push({
            label: element,
            value: element
          });
    });
    return options;
  };

  export const DEFAULT_OPTION = {
    label: '',
    value: ''
  };

const UserSearchWithSelectionChip = ({excludeUser,onUserAdded,onUserChanged}:any) => {

    const {data, isLoading } = useSearchUserIds();
    const setSearchQuery = useAppAdminStore((state) => state.setSearchQuery);
    const setUserId = useAppAdminStore((state) => state.setUserId);
    
    const [userList, setUserList] = useState<DropdownValue[]>([]);
    const [user, setUser] = useState<DropdownValue>({label:'',value:''});
    const { t } = useTranslation();

    const onSearchQueryChange = (query: any) =>{
        setSearchQuery(query);
    }

    const onDropdownChange = (event: any) =>{
        setUser(event);
        setSearchQuery(event.value);
        setUserId(event.value);
    }

    const onChipChange = (userList:any) =>{
      onUserChanged(userList);
    }

    const onChipAdded = (user:any) =>{
      onUserAdded(user);
    }
    
    useEffect(() => {
        setSearchQuery("");
    },[setSearchQuery]);

    useEffect(() => {
        if (data) {
            setUserList(createUserIdDropdownOptions(data));
        }
    },[data]);

    return (
        <div data-testid="autocomplete-inline">
        <AutocompleteDropdownWithChip
          id="user-search-dropdown"
          dataTestId="user-search-dropdown"
          onChangeInput={onSearchQueryChange}
          options={
              userList?.length
                ? userList
                : [DEFAULT_OPTION]
            }
          value={user}
          onChange={onDropdownChange}
          onChipChange={onChipChange}
          onChipAdded={onChipAdded}
          chipOptions={excludeUser}
          isLoading={isLoading}
          minChars={3}
          inputProps={
              {
                label:t('dealer-admin.ip-access.settings.userSearch'),
                placeholder:t('dealer-admin.ip-access.settings.userSearchPlaceholder'),
              }
          }
          emptySearchMsg={t('admin.user-search.no-user') as string}
          emptyRecordMsg={t('admin.user-search.no-record') as string}
          isHighlightRequired
        />
      </div>
    );
}


export {UserSearchWithSelectionChip};